import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { mediaBreakpointGte } from '../utils'
import {
  BackgroundProps,
  BorderProps,
  FlexboxProps,
  GridProps,
  LayoutProps,
  OverflowProps,
  SpaceProps,
  TypographyProps,
  background,
  border,
  flexbox,
  grid,
  layout,
  overflow,
  space,
  typography,
} from '../utils/styled-system'

const getPaddingDimensions = (padding?: SectionPadding) => {
  switch (padding) {
    case 'compact':
      return { mobilePadding: 24, desktopPadding: 32 }
    case 'spacey':
      return { mobilePadding: 64, desktopPadding: 96 }
    case 'spacier':
      return { mobilePadding: 80, desktopPadding: 160 }
    default:
      return { mobilePadding: 40, desktopPadding: 64 }
  }
}

export type SectionPadding = 'compact' | 'normal' | 'spacey' | 'spacier'

export type SectionProps = BackgroundProps &
  BorderProps &
  FlexboxProps &
  GridProps &
  LayoutProps &
  OverflowProps &
  SpaceProps &
  TypographyProps & {
    background?: string
    children?: ReactNode
    color?: string
    noSelect?: boolean
    spacing?: SectionPadding
  }

export const Section = styled.section<SectionProps>((props) => {
  const { mobilePadding, desktopPadding } = getPaddingDimensions(props.spacing)

  return {
    ...layout(props),
    background: props.background,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    ...background(props),
    ...border(props),
    color: props.color,
    display: 'flex',
    flexDirection: 'column',
    ...overflow(props),
    paddingBottom: mobilePadding,
    paddingTop: mobilePadding,
    position: 'relative',
    userSelect: props.noSelect ? 'none' : undefined,
    ...flexbox(props),
    ...grid(props),
    ...typography(props),
    ...space(props),
    [mediaBreakpointGte('md')]: {
      paddingBottom: desktopPadding,
      paddingTop: desktopPadding,
      ...space(props),
    },
  }
})
